import React, { Component } from 'react'

export const Error = ({ children, ...props }) => {

    return (
        <div style={{"color": "red"}}>{children}</div>
    )

}
